<template>
  <div class="mod_listbox__evaluation">
    <h3 v-if="title">
      <slot></slot>
    </h3>
    <ul class="mod__flex evaluation evaluation__type1">
      <li class="mod__flex__item -w20" :class="{'-active':rank==1}" @click="clickRank(1)">
        <slot name="rank1">-</slot>
      </li>
      <li class="mod__flex__item -w20" :class="{'-active':rank==2}" @click="clickRank(2)">
        <slot name="rank2">-</slot>
      </li>
      <li class="mod__flex__item -w20" :class="{'-active':rank==3}" @click="clickRank(3)">
        <slot name="rank3">-</slot>
      </li>
      <li class="mod__flex__item -w20" :class="{'-active':rank==4}" @click="clickRank(4)">
        <slot name="rank4">-</slot>
      </li>
      <li class="mod__flex__item -w20" :class="{'-active':rank==5}" @click="clickRank(5)">
        <slot name="rank5">-</slot>
      </li>
    </ul>
  </div>
</template>
<script>
  export default {
    props: {
      rank: {
        default: 3
      },
      title: {
        default: true
      }
    },
    methods: {
      clickRank: function (rank) {
        this.$emit('update:rank', rank)
      }
    }
  }
</script>
<style scoped lang="scss">
  .mod__flex {
    display: flex;
    flex-wrap: wrap;

  }

  .mod_listbox .evaluation__type1 {
    border: 1px solid #ccc;
    text-align: center;
    color: #ccc;
    overflow: hidden;
    li{
      border-right: 1px solid #ccc;
      border-right-width: 1px;
      border-right-style: solid;
      border-right-color: rgb(204, 204, 204);
      border-bottom: none;
      border-bottom-width: initial;
      border-bottom-style: none;
      border-bottom-color: initial;
    }
  }

  .mod__flex .mod__flex__item.-w20 {
    width: 20%;
    padding: 8px 0;
  }

  .mod_listbox .evaluation__type1 li.-active {
    background: #5553CF;
    color: #fff;
  }


</style>



// WEBPACK FOOTER //
// EvaluationType1.vue?690eb6f8